import React, { useState, useEffect } from 'react'
import { X } from 'lucide-react'
import { adminbell, info, moon, not } from '../../assets/assets'
import { Link, useLocation } from 'react-router-dom'
import NotificationBadge from '../NotificationBadge'
import ThemeToggle from '../ThemeToggle'
import { useAuthStore } from '../../store/authStore'

const AdminHeader = () => {
    const { user } = useAuthStore()
  const location = useLocation()
  const [breadcrumbs, setBreadcrumbs] = useState([])
  const [pageTitle, setPageTitle] = useState('')

  // Function to convert URL segments to readable text
  const formatSegment = (segment) => {
    return segment
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }

  // Generate breadcrumbs and page title from URL
  useEffect(() => {
    const pathname = location.pathname
    const segments = pathname.split('/').filter(segment => segment !== '')
    
    // Remove 'admins' from segments if it exists
    const filteredSegments = segments.filter(segment => segment !== 'admins')
    
    // Always start with 'Pages'
    const breadcrumbItems = ['Pages']
    
    // Add formatted segments
    filteredSegments.forEach(segment => {
      breadcrumbItems.push(formatSegment(segment))
    })
    
    setBreadcrumbs(breadcrumbItems)
    
    // Set page title (last segment or 'Dashboard' if no segments)
    if (filteredSegments.length > 0) {
      setPageTitle(formatSegment(filteredSegments[filteredSegments.length - 1]))
    } else {
      setPageTitle('Dashboard')
    }
  }, [location.pathname])



  return (
    <div className="md:px-6 py-2 md:py-4">
      <div className="flex md:justify-between flex-col md:flex-row md:items-center">
        {/* Left side - Breadcrumbs and Title */}
        <div>
          {/* Breadcrumbs */}
          <nav className="flex items-center space-x-2 text-sm text-gray-500 dark:text-gray-400 breadcrumbs mb-1">
            {breadcrumbs.map((crumb, index) => (
              <React.Fragment key={index}>
                <span className={index === breadcrumbs.length - 1 ? 'text-gray-500 dark:text-gray-300 font-medium breadcrumbs' : ''}>
                  {crumb}
                </span>
                {index < breadcrumbs.length - 1 && (
                  <span className="text-gray-400 dark:text-gray-500">/</span>
                )}
              </React.Fragment>
            ))}
          </nav>
          
          {/* Page Title */}
          <h1 className="text-3xl font-bold text-[#174568] dark:text-blue-400 mb-8">{pageTitle}</h1>
        </div>
        
        {/* Right side - Search, Notifications, Profile */}
        <div className="w-[fit-content] flex items-center space-x-4 bg-white dark:bg-[#1d2026] rounded-full px-2 py-2">
      
          
          {/* Notification Icon with Badge */}
          <NotificationBadge className="hover:bg-gray-100 dark:hover:bg-gray-700 rounded-full !text-inherit" />
          
          {/* Dark Mode Toggle */}
          <ThemeToggle />
          
      
          {/* User Avatar */}
          <div className="w-7 h-7 md:w-10 md:h-10 rounded-full border-[1px] border-gray-200 dark:border-[#32353c] bg-gray-200 dark:bg-gray-600 overflow-hidden">
          <img 
  src={user?.profilePicture || "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=40&h=40&fit=crop&crop=face"} 
  alt="User" 
  className="w-full h-full object-cover" 
/>

          </div>
        </div>
      </div>


    </div>
  )
}

export default AdminHeader